/**
 * Cast slot geometry — the fixed top-right rectangle shared by THREE documents
 * (viewercontrols-plan §5b "clipped corner"):
 *
 *   - viewershaka (z1) positions the real cast/AirPlay button inside it,
 *   - viewercontrols (z3) keeps the slot free of content (title margin),
 *   - the HOST cuts the slot out of the controls iframe's hit-test area with a
 *     clip-path, so a click there falls through z3 (and the pointer-dead z2)
 *     to the real button in z1 — the only web mechanism that carries the
 *     user-activation the cast/AirPlay pickers require.
 *
 * All three iframes are viewport-sized, so vw/vh values line up exactly across
 * documents. The button aligns with the controls top bar (top 4.6vh, right
 * 6.2vw, 54px tall — the Back button's row).
 */

/** Button square, px (matches the controls' 54px Back-button row height). */
export const CAST_BTN_PX = 54

/** Breathing room around the button inside the slot, px. */
const SLOT_PAD_PX = 18

/** Slot rectangle, anchored to the viewport's top-right corner. */
export const SLOT_WIDTH = `calc(6.2vw + ${CAST_BTN_PX + SLOT_PAD_PX}px)`
export const SLOT_HEIGHT = `calc(4.6vh + ${CAST_BTN_PX + SLOT_PAD_PX}px)`

/** Horizontal room the controls must leave clear of the slot (title margin). */
export const SLOT_TITLE_CLEARANCE_PX = CAST_BTN_PX + SLOT_PAD_PX

/**
 * The controls-iframe clip-path: the full viewport MINUS the slot rectangle
 * (an L-shape). A clipped region is excluded from hit-testing, so pointer
 * events in the slot reach the z1 cast button underneath.
 */
export const CONTROLS_CLIP_PATH = `polygon(
  0 0,
  calc(100% - ${SLOT_WIDTH}) 0,
  calc(100% - ${SLOT_WIDTH}) ${SLOT_HEIGHT},
  100% ${SLOT_HEIGHT},
  100% 100%,
  0 100%
)`
